import gql from 'graphql-tag'
import numeral from 'numeral'
import client from '@stores/apollo'
import { getBuilding } from './create'

interface Props {
  id: string
  cost: string
  buildingId: string
  year: number
}
export default async function update({ id, cost, buildingId, year }: Props) {
  cost = numeral(cost).format('0.00')
  const variables = { input: { id, cost } }
  await client.gql.mutate({ mutation, variables })
  const { building } = await getBuilding(buildingId, year)
  return building
}

const mutation = gql`
  mutation updateOpsCost($input: UpdateContractInput!) {
    updateContract(input: $input) {
      contract {
        id
      }
    }
  }
`
